<div class="main-layout">
<app-navbar></app-navbar>
<div class="main-layout-content">
  <router-outlet ></router-outlet>
</div>
</div>